import React from "react";
import styled from "styled-components";
import Tasas from "./tasas";

const DataList = styled.dl`
  margin: 0;
  padding: 0;
  line-height: 1.5em;

  dt {
    font-weight: bold;
    margin: 0 0 ${props => props.theme.space[1]}px;
  }

  dd {
    margin: 0 0 ${props => props.theme.space[4]}px;
  }

  .section {
    border-top: ${props => props.theme.colors.grisMedio} 1px solid;
    padding-top: ${props => props.theme.space[3]}px;

    dt {
      font-size: 1.2em;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  p {
    margin-top: 0;
  }

  a,
  a:visited {
    text-decoration: none;
    color: ${props => props.theme.colors.amexBlue};
    border-bottom: solid 1px;
    border-color: transparent;
    transition: border-color 0.3s;
  }

  a:hover {
    border-color: ${props => props.theme.colors.amexBlue};
  }
`;

export default ({ producto, tasasDeInteres }) => {
  // TODO simplificar con un reduce
  const reglas = producto.planDeLealtad.reglasDeAcumulacion
    .filter(r => r.colores.map(c => c.titulo).includes(producto.color.titulo))
    .map(r => r.reglas.childMarkdownRemark.html)
    .join("");

  const def = ">>>>DEFINIR!!!";
  const items = [
    { title: "Monedas", value: producto.monedas.join(", ") },
    { title: "Programa de Lealtad", value: producto.planDeLealtad.titulo },
    {
      title: "Forma de acumulación",
      value: (
        <div
          dangerouslySetInnerHTML={{
            __html: reglas || def
          }}
        />
      )
    },
    {
      title: "Mínimo de redención",
      value: producto.planDeLealtad.minimoDeRedencion || def
    },
    {
      title: "Máximo de acumulación",
      value: producto.planDeLealtad.maximoDeAcumulacion || def
    },
    // TODO agregar unidad de acumulación
    {
      title: "Vencimiento de millas",
      value: producto.planDeLealtad.vencimientoDePuntos || def
    },
    {
      title: "Método de canje",
      value: (
        <div
          dangerouslySetInnerHTML={{
            __html:
              producto.planDeLealtad.metodoDeRedencion.childMarkdownRemark
                .html || def
          }}
        />
      )
    },
    {
      title: "Marca",
      value: producto.emisor.nombre
    },
    {
      title: "Límite de crédito",
      value: producto.limite
    },
    {
      title: `${producto.tipoDeCosto}`,
      value: `${producto.monedaDeCosto}${producto.costo}` || def
    },
    // TODO Poner en contentful
    {
      title: "Donde no acumula",
      value:
        "Cargos automáticos, extra financiamiento, compras con Tasa Cero y MiniCuotas o cualquier otra transacción de un comercio que no esté clasificado dentro de las categorías aprobadas por el programa no contabilizan en la acumulación de este programa de lealtad, retiros de efectivos (cajeros automáticos o ventanillas), transacciones en casinos y lugares de juegos de azar, night clubs, pagos de seguros, programas cero por ciento interés, comisiones por retiros de efectivo, servicios de telecomunicaciones, pagos de peajes o parqueos, cargos por concepto de membresías, administración de cuenta, intereses corrientes, intereses moratorios o anualidades, cargos por servicios públicos: electricidad, servicio de telecomunicaciones, agua, impuestos, marchamos del INS, permisos de construcción, pagos de multas, tasas y cualquiera otro ente gubernamental o débitos de beneficencia, los créditos o pagos que en su caso se apliquen a la cuenta del tarjetahabiente que correspondan o deriven de haber hecho efectivo alguno de los beneficios del programa o de contracargos, cargos por aclaraciones, reclamaciones, quejas de cargos que resulten improcedentes y en general todos aquellos que CREDOMATIC llegue a determinar no aplican, siendo en caso de duda determinante la existencia de el criterio de ánimo de lucro en la transacción comercial efectuada, en cuya ausencia la transacción no acumularán."
    },
    {
      title: "Requisitos",
      section: true,
      value: (
        <ul>
          {producto.requisitos.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      )
    },
    // TODO, folleto explicativo y contratos desde Contentful
    {
      title: "Vínculos de interés",
      section: true,
      value: (
        <ul>
          <li>
            <a href={producto.reglamento}>Reglamento</a>
          </li>
          <li>
            <a href={producto.terminosYCondiciones}>Términos y condiciones</a>
          </li>
          <li>
            <a href="https://issuu.com/credomatic/docs/compaginacionlecturadigitalfolletoe?e=19500127/31587712">
              Folleto explicativo de tarjeta de crédito
            </a>
          </li>
          <li>
            <a href="https://www.baccredomatic.com/es-cr/transparencia">
              Contratos
            </a>
          </li>
        </ul>
      )
    },
    {
      title: "Tasas de interés",
      section: true,
      value: <Tasas tasas={producto.tasasDeInteres} />
    }
  ];
  return (
    <div>
      <DataList>
        {items.map((item, i) => (
          <div key={i} className={item.section ? "section" : null}>
            <dt>{item.title}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </DataList>
    </div>
  );
};
